import type { PerilRecordDetail } from '../api/types'
import { embedUrlFor, externalMapUrlFor, mapQueryFor } from '../lib/maps'

/**
 * The Map tab of the details view, as the legacy K2 form has it.
 *
 * Rendered only while the tab is selected, so a record's address reaches Google
 * when an underwriter asks to see it on a map and not before.
 *
 * The embed is keyless and free, exactly as the legacy form's is. There is no
 * API key anywhere in this application. The "Open in Google Maps" link is always
 * shown beneath the map, so if the iframe is blocked by a network policy or an
 * extension the underwriter still has a way through, without this component
 * needing to detect the failure. A cross-origin iframe does not reliably report
 * one.
 */
export function MapPanel({ detail }: { detail: PerilRecordDetail }) {
  const query = mapQueryFor(detail)

  if (!query) {
    return <p className="map-note">This record carries no address to show on a map.</p>
  }

  return (
    <>
      <iframe
        className="map-frame"
        title={`Map of ${query}`}
        src={embedUrlFor(query)}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
      <p className="map-note">
        <a
          className="text-link"
          href={externalMapUrlFor(query)}
          target="_blank"
          rel="noreferrer"
        >
          Open in Google Maps
        </a>
      </p>
    </>
  )
}
